export const API_URL =
  "https://my-json-server.typicode.com/maulanadityaa/simple-cashier-fakeAPI/";
